'use es6';

import { OrderedMap, List } from 'immutable';
import { omit } from 'underscore';
import * as TicketApi from 'FormsUI/api/Ticket';
import { updateFormFieldDefinition } from './FormDefinition';
import { TicketProperties } from 'forms-utils-lib/constants/Properties';
import { PropertyObjectTypes } from '../constants/PropertyObjectTypes';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
function createAction(name) {
  return `@@ticket/${name}`;
}
export const REQUEST_PIPELINES = createAction('REQUEST_PIPELINES');
export const SUCCEEDED_GETTING_PIPELINES = createAction('SUCCEEDED_GETTING_PIPELINES');
export const FAILED_GETTING_PIPELINES = createAction('FAILED_GETTING_PIPELINES');
export const RECEIVE_PIPELINES = createAction('RECEIVE_PIPELINES');
export const RECEIVE_PIPELINE_STAGES = createAction('RECEIVE_PIPELINE_STAGES');
const requestPipelines = () => ({
  type: REQUEST_PIPELINES
});
const succeededGettingPipelines = () => ({
  type: SUCCEEDED_GETTING_PIPELINES
});
const receivePipelines = payload => ({
  type: RECEIVE_PIPELINES,
  payload
});
const receivePipelineStages = payload => ({
  type: RECEIVE_PIPELINE_STAGES,
  payload
});
const failedGettingPipelines = () => ({
  type: FAILED_GETTING_PIPELINES
});
const mapByKey = (list, key) => list.reduce((builder, item) => builder.set(item[key], item), new OrderedMap());
export function setPipelineAndStage(pipeline = {}, pipelineStage = {}) {
  return (dispatch, getState) => {
    updateFormFieldDefinition(TicketProperties.PIPELINE, getObjectTypeIdValue(null, PropertyObjectTypes.TICKET), FormFieldKeys.DEFAULT_VALUE, pipeline.pipelineId)(dispatch, getState);
    updateFormFieldDefinition(TicketProperties.PIPELINE_STAGE, getObjectTypeIdValue(null, PropertyObjectTypes.TICKET), FormFieldKeys.DEFAULT_VALUE, pipelineStage.stageId)(dispatch, getState);
  };
}
export function fetchPipelines() {
  return dispatch => {
    dispatch(requestPipelines());
    TicketApi.fetchPipelines().then(pipelines => {
      const pipelineList = List(pipelines);
      const pipelinesOrderedMap = mapByKey(pipelineList.sortBy(({
        displayOrder
      }) => parseInt(displayOrder, 10)).map(pipeline => omit(pipeline, 'stages')), 'pipelineId');
      const pipelineStagesOrderedMap = mapByKey(pipelineList.reduce((memo, {
        stages
      }) => memo.push(...stages), List()).sortBy(({
        displayOrder
      }) => parseInt(displayOrder, 10)).sortBy(({
        pipelineId
      }) => parseInt(pipelinesOrderedMap.get(pipelineId).displayOrder, 10)), 'stageId');
      dispatch(succeededGettingPipelines());
      dispatch(receivePipelines(pipelinesOrderedMap));
      dispatch(receivePipelineStages(pipelineStagesOrderedMap));
    }).catch(dispatch.bind(null, failedGettingPipelines()));
  };
}